const style = {
  timelineWrapper: {
    border: '1px solid #bdbdbd',
    borderRadius: '4px',
    minHeight: '192px',
    maxHeight: '192px',
    overflow: 'auto',
  },
  timelineArrow: {
    color: '#9e9e9e',
  },
  timelineChip: {
    maxWidth: 132,
  },
  timelinePoper: {
    minWidth: 164,
    // marginBottom:` 8
  },
  poppeArrow: {
    width: 0,
    height: 0,
    borderLeft: '8px solid transparent',
    borderRight: '8px solid transparent',
    borderTop: '8px solid #7c4cdb',
  },
  prerecordedCallDialogWrapper: {
    minWidth: '648px',
    // minHeight: '292px'
  },
  flowWrapper: {
    position: "relative",
      overflow: "auto",
      width: "800px",
      height: "500px",
      maxHeight: "800px",
      backgroundColor: "background.paper",
      border: '1px solid #ccc'
  }
};
export default style;
  